import type { IconSvgObject } from './types';

const BorderHorizontalIcon: IconSvgObject = [
  ["path", { d: "M2.5 14V10M21.5 10V14M21.5 6.25V5.5C21.5 3.84315 20.1569 2.5 18.5 2.5H17.75M10 2.5H14M6.25 2.5H5.5C3.84315 2.5 2.5 3.84315 2.5 5.5V6.25M21.5 17.75V18.5C21.5 20.1569 20.1569 21.5 18.5 21.5H17.75M10 21.5H14M6.25 21.5H5.5C3.84315 21.5 2.5 20.1569 2.5 18.5V17.75", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 9.15V14.85M12 19.6V21.5M12 2.5V4.4M21.5 11.9995H2.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default BorderHorizontalIcon;
